/** পণ্য, ভ্যারিয়েন্ট, দাম ও ক্যাটালগের তথ্য। */
export const catalog = {
    products: {
        title: "পণ্য",
        description: "আপনি যা বিক্রি করেন — ভ্যারিয়েন্ট, দাম ও বারকোডসহ।",
        add: "পণ্য যোগ করুন",
        back: "সব পণ্য",
        empty: "এখনো কোনো পণ্য নেই। প্রথম পণ্যটি যোগ করুন।",
        emptyArchived: "আর্কাইভ করা কোনো পণ্য নেই।",
        columns: { name: "নাম", category: "ক্যাটাগরি", variants: "ভ্যারিয়েন্ট", price: "দাম", status: "অবস্থা" },
        filters: { status: "অবস্থা", category: "ক্যাটাগরি", all: "সব" },
        created: "পণ্য যোগ হয়েছে।",
        saved: "পণ্য সংরক্ষিত হয়েছে।",
        archive: "পণ্য আর্কাইভ করুন",
        unarchive: "ফিরিয়ে আনুন",
        archiveTitle: "এই পণ্যটি আর্কাইভ করবেন?",
        archiveBody: "এটি POS ও সার্চ থেকে সরে যাবে। রিপোর্টে এর ইতিহাস থাকবে।",
        archived: "পণ্য আর্কাইভ হয়েছে।",
        unarchived: "পণ্য আবার সক্রিয়।",
    },
    bin: {
        trash: "ট্র্যাশ",
        emptyTrash: "ট্র্যাশে কোনো পণ্য নেই।",
        selected_one: "{{count}}টি পণ্য বাছাই করা হয়েছে",
        selected_other: "{{count}}টি পণ্য বাছাই করা হয়েছে",
        delete: "মুছুন",
        archive: "আর্কাইভ",
        unarchive: "ফিরিয়ে আনুন",
        restore: "ফেরত আনুন",
        deleteForever: "স্থায়ীভাবে মুছুন",
        empty: "ট্র্যাশ খালি করুন",
        deleteTitle_one: "এই পণ্যটি মুছবেন?",
        deleteTitle_other: "{{count}}টি পণ্য মুছবেন?",
        deleteBody: "মোছা পণ্য ট্র্যাশে যাবে, সেখান থেকে ফেরত আনা যাবে। বিক্রি বা স্টকের ইতিহাস আছে এমন পণ্য মোছার বদলে আর্কাইভ হবে, যাতে রিপোর্ট ঠিক থাকে।",
        permanent: "এখনই স্থায়ীভাবে মুছুন (ট্র্যাশে না পাঠিয়ে)",
        permanentHint: "এটা আর ফেরানো যাবে না। এদের SKU ও বারকোড আবার ব্যবহার করা যাবে।",
        foreverTitle_one: "এই পণ্যটি স্থায়ীভাবে মুছবেন?",
        foreverTitle_other: "{{count}}টি পণ্য স্থায়ীভাবে মুছবেন?",
        foreverBody: "এটা আর ফেরানো যাবে না। এর মধ্যে ইতিহাস তৈরি হয়ে থাকলে সেগুলো আর্কাইভ হবে।",
        emptyTitle: "ট্র্যাশ খালি করবেন?",
        emptyBody: "ট্র্যাশের সব পণ্য স্থায়ীভাবে মুছে যাবে। এটা আর ফেরানো যাবে না।",
        trashed_one: "{{count}}টি পণ্য ট্র্যাশে গেছে।",
        trashed_other: "{{count}}টি পণ্য ট্র্যাশে গেছে।",
        deleted_one: "{{count}}টি পণ্য স্থায়ীভাবে মুছে গেছে।",
        deleted_other: "{{count}}টি পণ্য স্থায়ীভাবে মুছে গেছে।",
        archived_one: "{{count}}টি পণ্য মোছার বদলে আর্কাইভ হয়েছে: এর বিক্রি বা স্টকের ইতিহাস আছে।",
        archived_other: "{{count}}টি পণ্য মোছার বদলে আর্কাইভ হয়েছে: এদের বিক্রি বা স্টকের ইতিহাস আছে।",
        restored_one: "{{count}}টি পণ্য ফেরত এসেছে।",
        restored_other: "{{count}}টি পণ্য ফেরত এসেছে।",
        changed_one: "{{count}}টি পণ্য হালনাগাদ হয়েছে।",
        changed_other: "{{count}}টি পণ্য হালনাগাদ হয়েছে।",
        remaining: "আরও {{count}}টি ট্র্যাশে আছে: আবার খালি করুন।",
        trashedOn: "মোছার তারিখ",
    },
    details: "পণ্যের বিবরণ",
    statuses: { active: "সক্রিয়", archived: "আর্কাইভ", trashed: "ট্র্যাশে", deleted: "মোছা" },
    types: { standard: "সাধারণ", weighed: "ওজনে বিক্রি", service: "সেবা (স্টক নেই)" },
    fields: {
        name: "নাম",
        description: "বিবরণ",
        type: "ধরন",
        unit: "একক",
        category: "ক্যাটাগরি",
        brand: "ব্র্যান্ড",
        none: "নেই",
        taxPercent: "ভ্যাট %",
        taxPercentHint: "খালি রাখলে ক্যাটাগরির হার প্রযোজ্য হবে।",
        trackInventory: "স্টক হিসাব রাখুন",
        allowNegative: "স্টক শূন্যের নিচে গেলেও বিক্রি চলবে",
    },
    options: {
        title: "অপশন",
        description: "সর্বোচ্চ ৩টি অপশন, যেমন সাইজ বা রং। প্রতিটি কম্বিনেশন একটি ভ্যারিয়েন্ট হবে।",
        name: "অপশনের নাম",
        values: "মানগুলো",
        valuesHint: "কমা দিয়ে আলাদা করুন: S, M, L",
        add: "অপশন যোগ করুন",
        remove: "অপশন সরান",
    },
    variants: {
        title: "ভ্যারিয়েন্ট",
        newTitle: "নতুন কম্বিনেশন",
        newDescription: "এই কম্বিনেশনগুলো নতুন। প্রতিটির দাম দিন।",
        single: "দাম ও কোড",
        variant: "ভ্যারিয়েন্ট",
        sku: "SKU",
        skuHint: "খালি রাখলে নিজে থেকে তৈরি হবে।",
        price: "দাম",
        cost: "ক্রয়মূল্য",
        mrp: "MRP",
        barcode: "বারকোড",
        barcodes: "বারকোড",
        generateBarcode: "বারকোড তৈরি করুন",
        status: "অবস্থা",
        noOptions: "ডিফল্ট",
        editPrices: "দাম বদলান",
        pricesTitle: "{{name}}-এর দাম",
        pricesSaved: "দাম সংরক্ষিত হয়েছে।",
        archive: "আর্কাইভ",
        unarchive: "ফিরিয়ে আনুন",
        archived: "ভ্যারিয়েন্ট আর্কাইভ হয়েছে।",
        unarchived: "ভ্যারিয়েন্ট আবার সক্রিয়।",
        selected_one: "{{count}}টি ভ্যারিয়েন্ট বাছাই করা",
        selected_other: "{{count}}টি ভ্যারিয়েন্ট বাছাই করা",
        bulkEdit: "দাম বদলান",
    },
    labels: {
        print: "লেবেল প্রিন্ট",
        printSelected: "লেবেল প্রিন্ট",
        title: "বারকোড লেবেল প্রিন্ট",
        description: "বাছাই করা পণ্যের স্টিকার। PDF নতুন ট্যাবে খুলবে; আসল মাপে (১০০ %) প্রিন্ট করুন।",
        copies: "কপি",
        noBarcode: "এখনো বারকোড নেই",
        generate: "তৈরি করুন",
        generated: "বারকোড তৈরি হয়েছে।",
        layout: "লেবেলের মাপ",
        layouts: {
            a4_65: "A4 · ৬৫টি · ৩৮×২১ মিমি",
            a4_40: "A4 · ৪০টি · ৫২×৩০ মিমি",
            a4_24: "A4 · ২৪টি · ৭০×৩৭ মিমি",
            roll_38x25: "রোল · ৩৮×২৫ মিমি",
            roll_50x25: "রোল · ৫০×২৫ মিমি",
            roll_50x30: "রোল · ৫০×৩০ মিমি",
        },
        show: "লেবেলে যা থাকবে",
        fields: {
            businessName: "ব্যবসার নাম",
            productName: "পণ্যের নাম",
            price: "দাম",
            mrp: "এমআরপি",
            sku: "SKU",
        },
        branch: "যে শাখার দাম",
        basePrice: "মূল দাম",
        skip: "শিটে আগে ব্যবহৃত স্টিকার",
        skipHelp: "এগুলোর পর থেকে প্রিন্ট শুরু হবে, বাঁ থেকে ডানে, উপর থেকে নিচে।",
        total_one: "{{formatted}}টি লেবেল",
        total_other: "{{formatted}}টি লেবেল",
        tooMany: "একবারে সর্বোচ্চ ২,০০০টি লেবেল।",
        submit: "PDF তৈরি করুন",
        ready: "লেবেল প্রস্তুত।",
        open: "PDF খুলুন",
        missing: "চিহ্নিত পণ্যগুলোর আগে বারকোড তৈরি করুন।",
    },
    bulk: {
        title: "{{count}}টি ভ্যারিয়েন্টের দাম বদলান",
        field: "কী বদলাবেন",
        fields: { price: "বিক্রয়মূল্য", cost: "ক্রয়মূল্য" },
        mode: "কীভাবে",
        modes: { set: "নির্দিষ্ট টাকা", increase: "% বাড়ান", decrease: "% কমান" },
        amount: "টাকা",
        percent: "শতাংশ",
        done_one: "{{count}}টি ভ্যারিয়েন্ট বদলানো হয়েছে।",
        done_other: "{{count}}টি ভ্যারিয়েন্ট বদলানো হয়েছে।",
    },
    images: {
        title: "ছবি",
        description: "সর্বোচ্চ ৮টি ছবি। তালিকায় প্রথমটি দেখানো হয়।",
        upload: "ছবি যোগ করুন",
        uploading: "আপলোড হচ্ছে…",
        remove: "ছবি সরান",
        failed: "ছবি আপলোড করা যায়নি। JPEG, PNG বা WebP ছবি দিন।",
        image: "পণ্যের ছবি",
    },
    tags: { title: "ট্যাগ", empty: "এখনো কোনো ট্যাগ নেই। ক্যাটালগ সেটআপে যোগ করুন।" },
    locationPrices: {
        title: "শাখার দাম",
        description: "কোনো শাখা নিজের দামে বিক্রি করতে পারে। খালি থাকলে মূল দাম প্রযোজ্য।",
        mainPrice: "মূল দাম: {{price}}",
        save: "ঠিক করুন",
        useMain: "মূল দাম ব্যবহার করুন",
        saved: "শাখার দাম ঠিক হয়েছে।",
        cleared: "শাখা আবার মূল দামে বিক্রি করবে।",
        empty: "এখনো কোনো শাখা নেই।",
    },
    history: {
        title: "দামের ইতিহাস",
        empty: "এখনো দাম বদলানো হয়নি।",
        fields: { price: "দাম", cost: "ক্রয়মূল্য", mrp: "MRP" },
        allLocations: "সব শাখা",
        none: "নেই",
    },
    search: {
        label: "পণ্য খুঁজুন",
        placeholder: "নাম, SKU বা বারকোড",
        empty: "“{{q}}”-এর সাথে মেলে এমন কোনো পণ্য নেই।",
        columns: { product: "পণ্য", variant: "ভ্যারিয়েন্ট", sku: "SKU", price: "দাম" },
        rebuild: "সার্চ ইনডেক্স নতুন করে তৈরি করুন",
        rebuildHint: "সার্চের ফল পুরোনো মনে হলে এটি ব্যবহার করুন। এটি পেছনে চলে।",
        rebuildQueued: "সার্চ ইনডেক্স নতুন করে তৈরি হচ্ছে।",
    },
    imports: {
        title: "ইমপোর্ট / এক্সপোর্ট",
        description: "Excel বা CSV থেকে একসাথে অনেক পণ্য যোগ বা হালনাগাদ করুন, অথবা সব ডাউনলোড করুন।",
        template: "টেমপ্লেট ডাউনলোড করুন",
        templateHint: "প্রতিটি ভ্যারিয়েন্টের জন্য একটি সারি। দ্বিতীয় শিটে প্রতিটি কলামের ব্যাখ্যা আছে।",
        templateXlsx: "Excel টেমপ্লেট",
        templateCsv: "CSV টেমপ্লেট",
        download: "ডাউনলোড",
        upload: "ফাইল ইমপোর্ট করুন",
        file: "ফাইল (.xlsx বা .csv)",
        mode: "কিছু সারিতে ভুল থাকলে",
        modes: {
            skip_bad_rows: "ঠিক সারিগুলো ইমপোর্ট করুন, ভুলগুলো বাদ দিন",
            all_or_nothing: "কিছুই ইমপোর্ট করবেন না",
        },
        match: "যে পণ্য আগে থেকেই আছে",
        matches: {
            create_only: "শুধু নতুনগুলো যোগ করুন",
            upsert_by_sku: "SKU দিয়ে পণ্য হালনাগাদ",
            upsert_by_phone: "ফোন দিয়ে কাস্টমার হালনাগাদ",
        },
        kind: "কী ইমপোর্ট বা এক্সপোর্ট করবেন",
        kinds: { products: "পণ্য", customers: "কাস্টমার" },
        check: "ফাইল যাচাই করুন",
        uploading: "আপলোড হচ্ছে…",
        uploadFailed: "ফাইলটি আপলোড করা যায়নি। ১০ MB পর্যন্ত .xlsx বা .csv ফাইল দিন।",
        history: "সাম্প্রতিক ইমপোর্ট",
        empty: "এখনো কোনো ইমপোর্ট হয়নি।",
        back: "ইমপোর্ট / এক্সপোর্ট",
        columns: { file: "ফাইল", status: "অবস্থা", rows: "সারি", result: "ফল", started: "শুরু" },
        statuses: {
            validating: "যাচাই হচ্ছে…",
            validated: "যাচাই শেষ — প্রয়োগের জন্য প্রস্তুত",
            committing: "প্রয়োগ হচ্ছে…",
            completed: "সম্পন্ন",
            failed: "ব্যর্থ",
        },
        failures: {
            unreadable: "ফাইলটি পড়া যায়নি।",
            missing_columns: "কিছু দরকারি কলাম নেই। টেমপ্লেট থেকে শুরু করুন।",
            too_many_rows: "ফাইলে ১০,০০০-এর বেশি সারি আছে। ছোট ফাইলে ভাগ করুন।",
            empty_file: "ফাইলটি খালি।",
            has_errors: "কিছু সারিতে ভুল থাকায় কিছুই ইমপোর্ট হয়নি।",
            cancelled: "বাতিল করা হয়েছে।",
            crashed: "হঠাৎ থেমে গেছে। শেষ করতে “SKU মিলিয়ে হালনাগাদ করুন” দিয়ে ফাইলটি আবার চালান।",
        },
        tiles: {
            rows: "সারি",
            errors: "ত্রুটিযুক্ত সারি",
            create: "নতুন পণ্য",
            update: "আপডেট হবে এমন ভ্যারিয়েন্ট",
        },
        summary: {
            rows: "সারি: {{count}}",
            errors: "ভুল থাকা সারি: {{count}}",
            create: "নতুন পণ্য: {{count}}",
            update: "হালনাগাদ হবে এমন ভ্যারিয়েন্ট: {{count}}",
            result: "যোগ {{created}}, হালনাগাদ {{updated}}, বাদ {{skipped}}",
        },
        preview: "যা ইমপোর্ট হবে",
        previewColumns: { product: "পণ্য", action: "কাজ", variants: "ভ্যারিয়েন্ট", row: "সারি" },
        actions: { create: "যোগ", update: "হালনাগাদ" },
        errors: "ভুল থাকা সারি",
        errorColumns: { row: "সারি", column: "কলাম", message: "সমস্যা" },
        errorReport: "ভুল সারিগুলো ডাউনলোড করুন (Excel)",
        commit: "ইমপোর্ট প্রয়োগ করুন",
        cancel: "ইমপোর্ট বাতিল করুন",
        committed: "ইমপোর্ট প্রয়োগ হচ্ছে।",
        cancelledToast: "ইমপোর্ট বাতিল হয়েছে।",
        export: "পণ্য এক্সপোর্ট করুন",
        exportHint: "সব পণ্য ও ভ্যারিয়েন্ট ইমপোর্টের কলামে: বদলে “SKU মিলিয়ে হালনাগাদ করুন” দিয়ে আবার ইমপোর্ট করুন।",
        exportXlsx: "Excel-এ এক্সপোর্ট",
        exportCsv: "CSV-তে এক্সপোর্ট",
        exporting: "এক্সপোর্ট হচ্ছে…",
        exported: "এক্সপোর্ট তৈরি: {{count}}টি সারি।",
    },
    aboveMrp: "দাম MRP-এর চেয়ে বেশি হতে পারে না।",
    conflict: "অন্য কেউ এটি বদলেছেন। সর্বশেষ মান দেখানো হচ্ছে; আবার বদলান।",
    setup: {
        title: "ক্যাটালগ সেটআপ",
        description: "আপনার পণ্যের ক্যাটাগরি, ব্র্যান্ড, ট্যাগ ও একক।",
        add: "যোগ করুন",
        edit: "সম্পাদনা",
        rename: "নাম বদলান",
        saved: "সংরক্ষিত হয়েছে।",
        deleted: "মুছে ফেলা হয়েছে।",
        deleteTitle: "{{name}} মুছবেন?",
        deleteBody: "এটি আর ফেরানো যাবে না।",
        search: "{{what}} খুঁজুন",
        noMatch: "“{{q}}”-এর সাথে কিছু মেলেনি।",
        actions: "{{name}}-এর কাজ",
        categories: {
            title: "ক্যাটাগরি",
            description: "সর্বোচ্চ ৩ স্তর, যেমন মুদি › চাল › বাসমতি।",
            empty: "এখনো কোনো ক্যাটাগরি নেই।",
            parent: "মূল ক্যাটাগরি",
            topLevel: "সবার উপরে",
            taxPercent: "ডিফল্ট ভ্যাট %",
            add: "ক্যাটাগরি যোগ করুন",
            addSub: "সাব-ক্যাটাগরি যোগ করুন",
            addSubTo: "{{name}}-এর নিচে সাব-ক্যাটাগরি যোগ করুন",
            subs_one: "{{count}}টি সাব-ক্যাটাগরি",
            subs_other: "{{count}}টি সাব-ক্যাটাগরি",
            vat: "ভ্যাট {{percent}}",
            level: "স্তর {{level}}",
            expandAll: "সব খুলুন",
            collapseAll: "সব বন্ধ করুন",
            expand: "{{name}}-এর সাব-ক্যাটাগরি দেখান",
            collapse: "{{name}}-এর সাব-ক্যাটাগরি লুকান",
            emptyHint: "পণ্যগুলো ভাগ করে রাখুন, যেমন মুদি › চাল › বাসমতি। ক্রেতা ও রিপোর্ট এগুলো ব্যবহার করে।",
        },
        brands: {
            title: "ব্র্যান্ড",
            empty: "এখনো কোনো ব্র্যান্ড নেই।",
            add: "ব্র্যান্ড যোগ করুন",
            emptyHint: "যেমন ACI, প্রাণ, আড়ং।",
        },
        tags: {
            title: "ট্যাগ",
            empty: "এখনো কোনো ট্যাগ নেই।",
            add: "ট্যাগ যোগ করুন",
            emptyHint: "যেকোনো লেবেল, যেমন নতুন, ঈদ অফার বা অর্গানিক।",
        },
        units: {
            title: "একক",
            empty: "এখনো কোনো একক নেই।",
            code: "কোড",
            codeHint: "ছোট হাতের অক্ষর ও সংখ্যা, যেমন packet।",
            precision: "দশমিক ঘর",
            precisionHint: "পিসের জন্য ০; কেজির জন্য ৩ (স্টক গ্রামে রাখা হয়)।",
            system: "বিল্ট-ইন",
            add: "একক যোগ করুন",
            name: "নাম",
        },
    },
    books: {
        selling: "কী বিক্রি করবেন?",
        physical: "সাধারণ পণ্য",
        physicalHint: "ক্রেতার কাছে পাঠানো হয়; স্টক থাকে।",
        digital: "ডিজিটাল পণ্য",
        digitalHint: "পাঠানোর কিছু নেই, স্টকও নেই: টাকা দেওয়ার পর ক্রেতা অনলাইনে পান।",
        both: "দুটোই",
        bothHint: "এক পেজে দুই দাম — যেমন হার্ড কপি ও ই-বুক। Format-এর মতো একটি অপশন যোগ করে ডিজিটাল সারিতে টিক দিন।",
        kind: "ডিজিটাল পণ্যের ধরন",
        kinds: { ebook: "ই-বুক (PDF, আপনার ওয়েবসাইটে পড়া যায়)" },
        digitalRow: "এটি ডিজিটাল সংস্করণ (ই-বুক)",
        ebookBadge: "ই-বুক",
        bookTitle: "বইয়ের তথ্য",
        bookDescription: "বইয়ের জন্য: পণ্যের পেজে দেখায়, লেখকের পেজ ও ফিল্টারে কাজে লাগে।",
        authors: "লেখক",
        addAuthor: "লেখক যোগ করুন",
        chooseAuthor: "একজন লেখক বাছুন",
        newAuthor: "নতুন লেখকের নাম",
        createAuthor: "তৈরি করুন",
        remove: "সরান",
        roles: { author: "লেখক", translator: "অনুবাদক", editor: "সম্পাদক" },
        isbn: "ISBN",
        pages: "পৃষ্ঠা",
        edition: "সংস্করণ",
        language: "ভাষা",
        year: "প্রকাশের বছর",
        publisherHint: "প্রকাশক হলো পণ্যের ব্র্যান্ড।",
    },
};
//# sourceMappingURL=catalog.js.map